// Л — списък на вносовете с копче „Отмени". Съществува, защото един файл със
// замени пише стотици редове (4 на замяна): без отмяна сгрешен внос се чисти
// само с ръчен SQL.

const fmt = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    return isNaN(d) ? iso : d.toLocaleString("bg-BG");
};

export const ImportBatches = ({batches, kind, onUndo, busy}) => {
    const mine = (batches || []).filter(b => b.kind === kind);
    if (mine.length === 0) return null;

    return (
        <details className="mt-3">
            <summary>Предишни качвания ({mine.length})</summary>
            <div className="table-responsive mt-2">
                <table className="table table-sm align-middle">
                    <thead>
                    <tr>
                        <th>Кога</th>
                        <th>Файл</th>
                        <th>Година</th>
                        <th>Землище</th>
                        <th>Качил</th>
                        <th className="text-end">Записани</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {mine.map(b => (
                        <tr key={b.id} className={b.undone_on ? "text-muted" : ""}>
                            <td>{fmt(b.create_on)}</td>
                            <td>{b.filename || "—"}</td>
                            <td>{b.year}</td>
                            <td>{b.settlement_name || b.settlement_ekatte}</td>
                            <td>{b.user}</td>
                            <td className="text-end">{b.rows_written}</td>
                            <td className="text-end">
                                {b.undone_on ? (
                                    <span style={{fontSize: "0.8rem"}}>
                                        отменен на {fmt(b.undone_on)} от {b.undone_by}
                                    </span>
                                ) : (
                                    <button type="button" className="btn btn-sm btn-outline-danger"
                                            disabled={busy}
                                            onClick={() => onUndo(b)}>
                                        Отмени
                                    </button>
                                )}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <p className="text-muted" style={{fontSize: "0.85rem"}}>
                Отмяната трие редовете, записани от този файл. Ако при качването е
                било включено „замести съществуващите“, изтритото тогава <strong>не
                се възстановява</strong>.
            </p>
        </details>
    );
};
